import React from "react";
import { Row, Col } from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import CustomerUserForm from "./CustomerUserAddUpdateForm";
import strings from "../../core/translate";

export default class CustomerUserAddUpdate extends CoreEngine {
  defaultPassword = "P@ssword123";

  constructor(props) {
    super(props);
    this.state = {
      id: "",
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: this.defaultPassword,
        cityId: "",
      },
      citylist: [],
      loading: false,
    };

    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    const { selectedMerchant } = this.props.match.params;
    this.pathname = `customers/${selectedMerchant}/users`;

    if (edit) {
      this.setState({
        id: edit.id || "",
        user: {
          firstName: edit.firstName || "",
          lastName: edit.lastName || "",
          email: edit.email || "",
          phoneNumber: edit.phoneNumber || "",
          password: "",
          cityId: edit.cityId || "",
        },
      });
    }
    this.prepareData();
  }

  async prepareData() {
    try {
      const response = await this.engine.getItemlistDirect("cities");
      if (response) {
        const data = response.data.items;
        const citylist = data.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ citylist });
      }
    } catch (error) {
      console.error("Error loading cities", error);
    }
  }

  changeInput = (e) => {
    const { name, value } = e.target || {};
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: trimmedValue,
      },
    }));
  };

  handleValidSubmit = async () => {
    this.setState({ loading: true });
    const { user } = this.state;
    const payload = {
      user: {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phoneNumber: user.phoneNumber,
        password: this.defaultPassword,
      },
      cityId: user.cityId,
    };

    const { selectedMerchant } = this.props.match.params;

    try {
      let response;
      if (this.state.id) {
        response = await this.engine.updateItem(
          this.pathname,
          this.state.id,
          payload
        );
      } else {
        response = await this.engine.saveItem(this.pathname, payload);
      }

      if ((response && response.status === 201) || response.status === 200) {
        this.props.history.push(
          `/admin/customer_user/${selectedMerchant}/users`
        );
      } else {
        alert(strings.error);
      }
      this.setState({ loading: false });
    } catch (error) {
      alert(strings.error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { user, citylist, loading } = this.state;

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <CustomerUserForm
              user={user}
              citylist={citylist}
              changeInput={this.changeInput}
              handleValidSubmit={this.handleValidSubmit}
              loading={loading}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
